import { finishCartIdentity } from 'src/functions/cartIdentity'
import type { Middleware } from 'redux'
import type { RootState } from './reducer'
import { commerceItems, trackCommerce } from 'src/functions/commerceTracking'

/** Observe successful cart actions, never hydration, restoration or price refresh. */
const commerceTrackingMiddleware: Middleware<{}, RootState> = store => next => action => {
  const observesAddition = action?.type === 'addWarenkorbItem' || action?.type === 'qtyWarenkorbItem'
  const key = observesAddition ? action.payload?.key : undefined
  const previousQty = typeof key === 'string' ? store.getState().Warenkorb.items[key]?.qty || 0 : 0
  const result = next(action)
  if (['removeWarenkorbItem', 'qtyWarenkorbItem', 'clearWarenkorb'].includes(action?.type) && !Object.keys(store.getState().Warenkorb.items).length) finishCartIdentity()
  if (typeof key !== 'string') return result
  try {
    const item = store.getState().Warenkorb.items[key]
    const increase = (item?.qty || 0) - previousQty
    if (item && increase > 0) {
      const items = commerceItems([{ id: item.id, key: item.key, qty: increase }])
      if (items.length) {
        trackCommerce('add_to_cart', { items })
        if (action.type === 'addWarenkorbItem' && action.meta?.recommendation)
          trackCommerce('recommendation_add', { items, recommendation: action.meta.recommendation })
      }
    }
  } catch { /* A telemetry failure must not turn a successful cart action into an error. */ }
  return result
}

export default commerceTrackingMiddleware
